'use client';

import { AuthControls } from '@bomdisoft/auth-bff';
import { Brand, CreditCardRoundedIcon, TopBar as SharedTopBar, type TopBarSecondaryLink } from '@bomdisoft/components';
import { account, billing, getLanguageFromLocale, login, logout, signUp } from '@bomdisoft/translations';
import { getSharedBillingUrl } from '@bomdisoft/utilities';
import { homeText, legalEyebrow, orderProduceText } from '@pieleaf/translations';
import { usePathname } from 'next/navigation';

const LEGAL_PATH_SUFFIXES = ['/privacy-policy', '/terms-of-service', '/security', '/gdpr', '/cookie-policy', '/data-deletion'];

export const TopBar = () => {
  const pathname = usePathname() ?? '';
  const lang = pathname.match(/^\/([a-z]{2,3})(?:\/|$)/)?.[1] ?? 'en';
  const language = getLanguageFromLocale(lang);
  const isLegal = LEGAL_PATH_SUFFIXES.some(suffix => pathname.endsWith(suffix) || pathname.includes(`${suffix}/`));

  const secondaryLink: TopBarSecondaryLink = isLegal ? { href: `/${lang}`, label: homeText[language], testId: 'top-bar-legal' } : { href: `/${lang}/privacy-policy`, label: legalEyebrow[language], testId: 'top-bar-legal' };

  // Sign-in enters through the shared control: it renders sign-in/sign-up when
  // there is no session and an account menu when there is, so the storefront
  // never has to know which state it is in.
  const authSlot = (
    <AuthControls
      accountHref={`/${lang}/account`}
      items={[{ external: true, href: getSharedBillingUrl(), icon: <CreditCardRoundedIcon />, label: billing[language], testId: 'top-bar-billing' }]}
      manageAccountLabel={account[language]}
      menuLabel={account[language]}
      signInLabel={login[language]}
      signOutLabel={logout[language]}
      signUpLabel={signUp[language]}
    />
  );

  return <SharedTopBar authSlot={authSlot} brand={<Brand href={`/${lang}`} logoHeight={28} logoWidth={28} priority size={20} testId='top-bar-brand' wordmarkSuffix='ieleaf' />} ctaHref={`/${lang}/orders`} ctaLabel={orderProduceText[language]} maxWidth={1200} secondaryLink={secondaryLink} />;
};
